import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const PictureInPicture = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.2 10.063V7.624c0-.431-.169-.844-.469-1.149A1.6 1.6 0 0 0 17.6 6h-12c-.424 0-.831.171-1.131.476S4 7.194 4 7.625v8.125c0 .894.72 1.625 1.6 1.625h3.2m4.8-4.062h4.8c.884 0 1.6.727 1.6 1.624v2.438c0 .898-.716 1.625-1.6 1.625h-4.8c-.884 0-1.6-.727-1.6-1.625v-2.437c0-.898.716-1.626 1.6-1.626"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(PictureInPicture) as SvgIcon;
export { ForwardRef as ReactComponent };
